
import UserEdit from "../../../assets/outline/UserEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UserEditIcon({ className, dataTestid = "UserEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <UserEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
